import React from 'react'

import { Partners, Cooperation } from 'components'
import { Separator } from 'shared/components'
import { FirstBlock } from './FirstBlock/FirstBlock'
// import { History } from './History/History'
import { MainWorkAreas } from './MainWorkAreas/MainWorkAreas'
import { Partnership } from './Partnership/Partnership'
import { PressMaterials } from './PressMaterials/PressMaterials'
import { AboutUsProduction } from './Production'
import { Vacancies } from './Vacancies/Vacancies'
import classes from './AboutUs.module.scss'
//
// const scenarioDesc =
//   'Если у вас есть интересная идея сценария,\nрасскажите нам о ней в анкете, и мы\nобязательно её рассмотрим.'

export const AboutUs = (): JSX.Element => {
  return (
    <>
      <FirstBlock />
      <MainWorkAreas />
      <AboutUsProduction />
      <Separator className={classes.separator} />
      <Partnership />
      {/* <History /> */}
      {/*<Scenario*/}
      {/*  desc={scenarioDesc}*/}
      {/*  btnTextLg="Заполните анкету сейчас"*/}
      {/*  btnTextSm="Заполните анкету"*/}
      {/*  screenName="/about"*/}
      {/*/>*/}
      <Cooperation page="about" />
      <Partners />
      <Vacancies />
      <PressMaterials title="Материалы для прессы" />
    </>
  )
}
